import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as ClaymationIcon } from "images/userDetails/claymation style.svg";
import ProfileSection from "../common/profileSection";
import PersonalInformation from "./personalInformation";
import Availability from "../common/availability";
import EmergencyContact from "./emergencyContact/index";
import Experience from "./experiance";
import { useSelector } from "react-redux";
import {
  STATUS_ACTIVE,
  STATUS_BLACKLIST,
  STATUS_QUALIFIED,
  STATUS_SUSPENDED,
  SUBSTATUS_AGREEMENT_SENT,
  SUBSTATUS_DECLINED_AGREEMENT,
  SUBSTATUS_DO_NOT_USE,
  SUBSTATUS_EXPIRED_AGREEMENT,
  SUBSTATUS_ONBOARDING_DONE,
  SUBSTATUS_PENDING_INVESTIGATION,
  SUBSTATUS_READY_FOR_WORK,
  SUBSTATUS_UNDER_VALIDATION,
} from "utils/constantValues";
import Qualifications from "./qualificationsSection";
import LegalDetails from "./legalDetailsSection";
import ContactDetails from "./contactDetailsSection";

function PersonalDetails() {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});
  const isShowEditIcon = ![STATUS_BLACKLIST, STATUS_SUSPENDED].includes(
    userDetails?.status
  );

  const showOnboardingForum =
    [
      STATUS_ACTIVE,
      STATUS_QUALIFIED,
      STATUS_BLACKLIST,
      STATUS_SUSPENDED,
    ].includes(userDetails?.status) &&
    [
      SUBSTATUS_READY_FOR_WORK,
      SUBSTATUS_ONBOARDING_DONE,
      SUBSTATUS_PENDING_INVESTIGATION,
      SUBSTATUS_DO_NOT_USE,
      SUBSTATUS_AGREEMENT_SENT,
      SUBSTATUS_DECLINED_AGREEMENT,
      SUBSTATUS_EXPIRED_AGREEMENT,
      SUBSTATUS_UNDER_VALIDATION,
    ].includes(userDetails?.subStatus);
  return (
    <ProfileSection
      icon={ClaymationIcon}
      title={t("personalDetails")}
      changeLogoButtonText={
        userDetails?.isVendor ? t("changeProfilePicture") : t("changeLogo")
      }
      logoFormatText={t("logoFormat")}
    >
      <div className="bg-[#E4E4E7] h-[1px] w-full" />
      <PersonalInformation isShowEditIcon={isShowEditIcon} />
      <div className="bg-[#E4E4E7] h-[1px] w-full" />
      <Availability isShowEditIcon={isShowEditIcon} />
      <div className="bg-[#E4E4E7] h-[1px] w-full" />
      <Experience isShowEditIcon={isShowEditIcon} />

      <div className="bg-[#E4E4E7] h-[1px] w-full" />
      {showOnboardingForum && (
        <>
          <Qualifications isShowEditIcon={isShowEditIcon} />
          <div className="bg-[#E4E4E7] h-[1px] w-full" />
        </>
      )}

      {showOnboardingForum && (
        <>
          <div className="grid w-full" id="contactDetailsScrollId">
            <ContactDetails isShowEditIcon={isShowEditIcon} />
          </div>
          <div className="bg-[#E4E4E7] h-[1px] w-full" />
        </>
      )}
      {showOnboardingForum && (
        <>
          <div className="grid w-full" id="legalDetailsScrollId">
            <LegalDetails isShowEditIcon={isShowEditIcon} />
          </div>
          <div className="bg-[#E4E4E7] h-[1px] w-full" />
        </>
      )}

      {showOnboardingForum && (
        <>
          <EmergencyContact isShowEditIcon={isShowEditIcon} />
        </>
      )}
    </ProfileSection>
  );
}

export default PersonalDetails;
